/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { RenderRequestDto } from '../models/RenderRequestDto';
import type { RenderResponseDto } from '../models/RenderResponseDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class DefaultService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param requestBody
     * @returns RenderResponseDto Rendered recommendations HTML
     * @throws ApiError
     */
    public postRecoRecommendationsFrontendRender(
        requestBody: RenderRequestDto,
    ): CancelablePromise<RenderResponseDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/reco/recommendations-frontend/render',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `X-Sprache & X-Land do not match`,
                504: `Processing the request took too long`,
            },
        });
    }
}
